import { Controller } from "@hotwired/stimulus"
import { configureRemoteSearch } from "../../shared/multi_select"

export default class extends Controller {
  static values = { loadUrl: String, changedUrl: String }

  connect() {
    this.select = this.element.matches("select") ? this.element : this.element.querySelector("select")
    this.changed = this.changed.bind(this)
    this.select.addEventListener("change", this.changed)
    this.cleanupRemoteSearch = configureRemoteSearch(this.select, {
      url: this.loadUrlValue,
      resultsKey: "users",
      valueField: "clerk_code",
      labelField: "chinese_name"
    })
  }

  disconnect() {
    this.cleanupRemoteSearch?.()
    this.select?.removeEventListener("change", this.changed)
  }

  changed(event) {
    if (!event.target.value) return

    const url = new URL(this.changedUrlValue, window.location.origin)
    url.searchParams.set("clerk_code", event.target.value)
    url.searchParams.set("month_name", document.getElementById("month_name")?.value || "")
    $.ajax(url.toString(), { dataType: "script" })
  }
}
